<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Patient List</a>
  </div>-->

  <div class="row">
    <div class="col-md-12">
      <div class="card my-profile-form margin-top-20px" *ngIf="ShowList">
        <div class="card-header wh-header padding-bottom-6px padding-left-13px">
          <div class="row">
            <div class="col-md-3">
              Treatment Cycles
            </div>
            <div class="col-md-8 padding-right-0px">
              <!--<div class="col-md-3 float-right padding-right-0px">
                <input type="text" class="form-control" placeholder="Search" (input)="criteriaChange($event.target.value)">
              </div>-->
              <!--<div class="row">
                <div class="offset-md-6 col-md-2 text-align-right padding-right-0px padding-left-0px padding-right-0px">
                  <a (click)="SearchPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
                </div>
                <div class="col-md-4 float-right padding-left-0px padding-right-0px">
                  <form novalidate="" #f="ngForm" class="display-inherit">
                    <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue'>
                    <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                  </form>
                </div>
              </div>-->

              <div class="row">
                <div class="offset-md-6 col-md-2 padding-right-0px text-align-center">
                  <a (click)="SearchPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New Cycle</a>
                </div>
                <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
                  <form novalidate="" #f="ngForm" class="display-inherit">
                    <div class="clear-form">
                      <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                      <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                    </div>
                    <!--<input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">-->
                    <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="card-body padding-top-0px">

          <div class="row">
            <!--<div class="margin-top-180px">
              <a class="nav-link-hand  back-link" title="Back To Profile" (click)="BackToTreatment()"><i class="fas fa-angle-double-left font-size-19px"></i></a>
            </div>-->
            <div class="col-md-12 padding-right-0px">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero"
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="">
                          PID
                        </th>
                        <!--<th class="text-align-center">Day</th>-->
                        <th class="">
                          Cycle#
                        </th>

                        <th class="padding-left-4">
                          Name
                        </th>
                        <!--<th class="text-align-center">Start Time</th>-->




                        <th class="">
                          Contact
                        </th>
                        <th class="padding-left-9px">
                          Sex &amp; Age
                        </th>

                        <th></th>
                        <th>Protocol</th>
                        <th>Prtcl Start Date</th>
                        <th class="padding-left-10px">Cycle Type</th>
                        <th>Duration</th>

                        <th>Status</th>
                        <th></th>



                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentTreatmentCyclesController">

                        <td class="td-padding-tb padding-top-0px padding-bottom-0px padding-right-0px"> <a (click)="ViewPatientDetails(l)" class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i> {{l.PatientRegNo}}</a>  </td>
                        <!--<td class="td-padding text-align-center">Mon</td>-->
                        <td class=" padding-top-0px padding-bottom-0px text-align-right ">
                          {{l.CycleNo}}
                        </td>
                        <td class="td-padding padding-top-0px padding-bottom-0px ">
                          {{l.DisplayName}}
                        </td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Telephone1}}</td>
                        <!--<td class="td-padding text-align-center"></td>-->
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Gender}} &amp; {{l.Age}}</td>

                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.TCModelName}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">{{l.ProtocolName}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">{{l.ProtocolStartDate| date:'MMM-dd-yyyy'}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px ">{{l.CycleType}}</td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Duration}} days</td>

                        <td class="padding-top-0px padding-bottom-0px">{{l.RecordStatus}}</td>


                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">
                          <button (click)="UpdateStatus(l)" class="btn actions-btn-prime font-size-13px">Update Status </button>

                        </td>



                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<div class="col-md-12" *ngIf="!ShowList">

  <treatmentCycle (GoBack)="OnGoBack()" [ActorCode]='SelectedPatient.ActorCode' [CycleCode]='SelectedPatient.Code' [Duration]='SelectedPatient.Duration' [GradingModel]='SelectedPatient.GradingModel' *ngIf="ShowPatientDetails"></treatmentCycle>
</div>
